import { render } from "./SettingsForm.vue?vue&type=template&id=80dc7746&scoped=true"
import script from "./SettingsForm.vue?vue&type=script&lang=js"
export * from "./SettingsForm.vue?vue&type=script&lang=js"

import "./SettingsForm.vue?vue&type=style&index=0&id=80dc7746&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4197/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80dc7746"]])

export default __exports__